import React from "react";
import { useSelector } from "react-redux";
import { DocumentacionReclamo } from "./DocumentacionReclamo";

export const DocumentacionIngreso = () => {
  const { reclamoTomado } = useSelector((state) => state.reclamos);

  return <DocumentacionReclamo solicitud={reclamoTomado} />;
};
